import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useCheckout } from "@/hooks/useCheckout";
import Header from "@/components/layout/Header";
import SEO from "@/components/seo/SEO";
import CheckoutCard from "@/components/checkout/CheckoutCard";
import { toast } from "sonner";

const Checkout: React.FC = () => {
  const [searchParams] = useSearchParams();
  const planType = searchParams.get("plan") as
    | "MONTHLY"
    | "YEARLY"
    | "SEMIANNUAL"
    | null;
  const navigate = useNavigate();
  const { user } = useAuth();

  // Redirect to login if not authenticated
  React.useEffect(() => {
    if (!user) {
      navigate("/login", {
        state: {
          from: "/checkout",
          planType,
        },
        replace: true,
      });
    }
  }, [user, planType, navigate]);

  // Show toast message if redirected from a failed checkout attempt
  React.useEffect(() => {
    const errorParam = searchParams.get("error");
    if (errorParam) {
      toast.error(decodeURIComponent(errorParam));
    }
  }, [searchParams]);

  // Use the checkout hook
  const { isLoading, error, errorDetails, debugInfo, retryCheckout } =
    useCheckout(planType);

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Complete Your Subscription | PetDocument"
        description="Complete your PetDocument subscription to unlock all features."
      />
      <Header />

      <main className="pt-24 pb-16">
        <div className="container-narrow">
          <div className="max-w-md mx-auto">
            <CheckoutCard
              planType={planType}
              isLoading={isLoading}
              error={error}
              errorDetails={errorDetails}
              debugInfo={debugInfo}
              onCheckout={retryCheckout}
              onRetry={retryCheckout}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Checkout;
